<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-transparent md-absolute"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
  >
  <!-- <img :src="avatar" alt="avatar" /> -->
    <div class="md-toolbar-row md-collapse-lateral">
      <img class="navbar-image white" src="@/assets/images/logo-white.png" alt="avatar"/>
      <img class="navbar-image black" src="@/assets/images/logo.png" alt="avatar"/>
      <!-- <div class="md-toolbar-section-start">
        <h3 class="md-title" style="margin-left:10px">GLOBAL MOBILITY SERVICE INDONESIA</h3>
      </div> -->
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            
            <md-list>
              <!-- <li class="md-list-item" v-if="!showDownload">
                <a
                  href="javascript:void(0)"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                    <drop-down direction="down">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple dropdown-toggle"
                        data-toggle="dropdown"
                      >
                        <i class="material-icons">apps</i>
                        <p>Components</p>
                      </md-button>
                      <ul class="dropdown-menu dropdown-with-icons">
                        <li>
                          <a href="#/">
                            <i class="material-icons">layers</i>
                            <p>All Components</p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://demos.creative-tim.com/vue-material-kit/documentation/"
                          >
                            <i class="material-icons">content_paste</i>
                            <p>Documentation</p>
                          </a>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </a>
              </li>
              <li class="md-list-item" v-else>
                <a
                  href="javascript:void(0)"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                    <drop-down direction="down">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple dropdown-toggle"
                        data-toggle="dropdown"
                      >
                        <i class="material-icons">view_carousel</i>
                        <p>Examples</p>
                      </md-button>
                      <ul class="dropdown-menu dropdown-with-icons">
                        <li>
                          <a href="#/landing">
                            <i class="material-icons">view_day</i>
                            <p>Landing Page</p>
                          </a>
                        </li>
                        <li>
                          <a href="#/login">
                            <i class="material-icons">fingerprint</i>
                            <p>Login Page</p>
                          </a>
                        </li>
                        <li>
                          <a href="#/profile">
                            <i class="material-icons">account_circle</i>
                            <p>Profile Page</p>
                          </a>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </a>
              </li> -->
              <md-list-item
                href="https://twitter.com/"
                target="_blank"
              >
                <i class="fab fa-twitter"></i>
                <p class="hidden-lg">Twitter</p>
                <md-tooltip md-direction="bottom"
                  >Follow us on Twitter</md-tooltip
                >
              </md-list-item>
              <md-list-item
                href="https://www.facebook.com/"
                target="_blank"
              >
                <i class="fab fa-facebook-square"></i>
                <p class="hidden-lg">Facebook</p>
                <md-tooltip md-direction="bottom"
                  >Like us on Facebook</md-tooltip
                >
              </md-list-item>
              <md-list-item
                href="https://www.instagram.com/"
                target="_blank"
              >
                <i class="fab fa-instagram"></i>
                <p class="hidden-lg">Instagram</p>
                <md-tooltip md-direction="bottom"
                  >Follow us on Instagram</md-tooltip
                >
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

// import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    // MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 400
    },
    header: {
      type: String,
      default: require("@/assets/images/charged_logo.png")
    }
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false,
    };
  },
  computed: {
    // showDownload() {
    //   const excludedRoutes = ["login", "landing", "profile"];
    //   return excludedRoutes.every(r => r !== this.$route.name);
    // }
    headerStyle() {
      return {
        Image: `url(${this.header})`
      };
    }
    
  },
  methods: {
    // bodyClick() {
    //   let bodyClick = document.getElementById("bodyClick");

    //   if (bodyClick === null) {
    //     let body = document.querySelector("body");
    //     let elem = document.createElement("div");
    //     elem.setAttribute("id", "bodyClick");
    //     body.appendChild(elem);

    //     let bodyClick = document.getElementById("bodyClick");
    //     bodyClick.addEventListener("click", this.toggleNavbarMobile);
    //   } else {
    //     bodyClick.remove();
    //   }
    // },
    // toggleNavbarMobile() {
    //   this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
    //   this.toggledClass = !this.toggledClass;
    //   this.bodyClick();
    // },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove("md-transparent");
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          navbarColor.classList.add("md-transparent");
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
    scrollToElement() {
      let element_id = document.getElementById("downloadSection");
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  }
};
</script>
<style lang="scss" scoped>
// .md-toolbar.md-theme-default.md-transparent, .md-toolbar.md-theme-default, .md-toolbar.md-theme-default .md-title, .md-toolbar.md-theme-default.md-transparent .md-title {
//     color: #555555;
// }
.md-toolbar.md-theme-default.md-transparent {
    background-color: transparent;
    color: rgba(0, 0, 0, 0.87);
    color: var(--md-theme-default-text-primary-on-background, rgba(0, 0, 0, 0.87));
}
.md-toolbar.md-theme-default.md-transparent .navbar-image.black {
  display: none;

}

.md-toolbar.md-white .navbar-image.white{
  display: none;
}

.md-toolbar.md-absolute {
    position: fixed;
    z-index: 1030;
    left: 0;
    right: 0;
    border-radius: 0;
}



.md-toolbar.md-transparent {
    background-color: transparent !important;
    -webkit-box-shadow: none;
    box-shadow: none;
    padding-top: 25px;
}
.md-toolbar.md-theme-default {
    color: rgba(0, 0, 0, 0.87);
    color: var(--md-theme-default-text-primary-on-background-variant, rgba(0, 0, 0, 0.87));
    background-color: #f5f5f5;
    background-color: var(--md-theme-default-toolbarvariant, #f5f5f5);
}

.md-toolbar {
    min-height: 56px;
    padding: 10px 15px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 3px;
    margin-bottom: 20px;
    background-color: #999999 !important;
    -webkit-box-shadow: 0 4px 20px 0px rgb(0 0 0 / 14%), 0 7px 12px -5px rgb(153 153 153 / 46%);
    box-shadow: 0 4px 20px 0px rgb(0 0 0 / 14%), 0 7px 12px -5px rgb(153 153 153 / 46%);
}
.caret, .md-toolbar {
    -webkit-transition: all 150ms ease-in;
    transition: all 150ms ease-in;
}

.md-toolbar .md-list {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row;
    flex-flow: row;
    padding-top: 0;
    padding-bottom: 0;
    color: inherit !important;
    background-color: transparent !important;
}

// .md-toolbar {
//     padding: 0 16px;
//     flex-flow: row wrap;
//     position: relative;
//     z-index: 2;
// }
.md-toolbar, .md-toolbar-row {
    width: 100%;
    min-height: 64px;
    display: flex;
    align-items: center;
    align-content: center;
    transition: .3s cubic-bezier(.4,0,.2,1);
    transition-property: opacity,background-color,box-shadow,transform,color,min-height;
    will-change: opacity,background-color,box-shadow,transform,color,min-height;
}
.md-elevation-0 {
    box-shadow: 0 0 0 0 rgb(0 0 0 / 20%), 0 0 0 0 rgb(0 0 0 / 14%), 0 0 0 0 rgb(0 0 0 / 12%);
}


.md-toolbar.md-white {
    background-color: #FFFFFF !important;
    height: 100px;
    -webkit-box-shadow: 0 4px 18px 0px rgb(0 0 0 / 12%), 0 7px 10px -5px rgb(0 0 0 / 15%);
    box-shadow: 0 4px 18px 0px rgb(0 0 0 / 12%), 0 7px 10px -5px rgb(0 0 0 / 15%);
}

.md-toolbar.md-theme-default.md-transparent, .md-toolbar.md-theme-default, .md-toolbar.md-theme-default .md-title, .md-toolbar.md-theme-default.md-transparent .md-title {
    color: #555555;
}
.md-toolbar.md-white .md-title, .md-toolbar.md-white .fab, .md-toolbar.md-white .md-list .md-list-item-content, .md-toolbar.md-white .md-toolbar-toggle .icon-bar, .md-toolbar.md-white, .md-toolbar.md-white:hover, .md-toolbar.md-white:focus {
    color: #555 !important;
}
.md-toolbar .md-title, .md-toolbar .md-list .md-list-item-content, .md-toolbar .md-toolbar-toggle .icon-bar, .md-toolbar, .md-toolbar:hover, .md-toolbar:focus {
    color: #FFFFFF !important;
}
// .md-toolbar.md-transparent .md-title, .md-toolbar.md-transparent .md-list .md-list-item-content, .md-toolbar.md-transparent .md-list-item-container .md-icon, .md-toolbar.md-transparent, .md-toolbar.md-transparent:hover, .md-toolbar.md-transparent:focus {
//     color: #FFFFFF !important;
// }

.md-list-item {
    height: auto;
    position: relative;
    z-index: 2;
}
.md-toolbar .md-title,.md-toolbar .fab, .md-toolbar .md-list .md-list-item-content, .md-toolbar .md-toolbar-toggle .icon-bar, .md-toolbar, .md-toolbar:hover, .md-toolbar:focus {
    color: #FFFFFF !important;
}

.md-toolbar .md-toolbar-row {
    min-height: auto;
    padding-left: 15px;
    padding-right: 15px;
}
.md-toolbar-row, .section .container, .footer .container {
    max-width: 1140px;
}

.md-toolbar-row {
    align-self: flex-start;
}

.md-toolbar-row .navbar-image.black, .navbar-image.white{
    font-size: 20px;
    margin: 0 !important;
    height: 35px;
    color: #FFFFFF;
    min-width: 24px;
    text-align: center;

}


.md-toolbar-section-end {
    justify-content: flex-end;
    order: 10;
}
.md-toolbar-section-end, .md-toolbar-section-start {
    display: flex;
    align-items: center;
    flex: 1;
}
* {
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -webkit-tap-highlight-color: transparent;
}

h3 { 
    display: block;
    font-size: 1.17em;
    margin-top: 1em;
    margin-bottom: 1em;
    margin-left: 0;
    margin-right: 0;
    font-weight: bold;
}

h3, .md-title{
  font-weight: bold;
}
</style>
